module.exports = __webpack_public_path__ + "img/ads1.70122c3.svg";